import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogConfig } from '../shared.interface';

@Component({
    selector: 'app-dialog-generic',
    templateUrl: './dialog-generic.component.html',
    styleUrls: ['./dialog-generic.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogGenericComponent implements OnInit {
    @Input() config: DialogConfig;

    constructor(public activeModal: NgbActiveModal) {}

    returnValues = {};

    ngOnInit(): void {
      // console.log(this.config);
      if(this.config.body != null){
        Object.values(this.config.body).forEach(item => {
          if(item.hasOwnProperty('returnValue')){
            const key: string = item.returnValue
            this.returnValues[key] = "";
          }
        });
      }
    }

    onChange(key, value) {
      this.returnValues[key] = value;
    }

    close(cb): void {

      if(Object.keys(this.returnValues).length > 0){
        if (typeof cb === 'function')
          cb(this.returnValues);
        this.activeModal.close(() => {});
      }else{
        this.activeModal.close(cb);
      }
    }
}
